var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_link",
    d: "M0,14.938,10.608,4.327H1.7V0H18V16.3H13.667V7.389L3.059,18Z",
    fill: "#003FB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisit);
export default __webpack_public_path__ + "static/media/ic_visit.f6256ff8e9b9645dc6a95be103b8016d.svg";
export { ForwardRef as ReactComponent };